// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
//import VuejsDialog from "vuejs-dialog"
import wysiwyg from "./editor";

// Tell Vue to install the plugin.
//Vue.use(VuejsDialog)
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    orderedList: true,
    unorderedList: true,
  },

  // you can override icons too, if desired
  // just keep in mind that you may need custom styles in your application to get everything to align
  //iconOverrides: { "bold ': '<i class='your-custom-icon'></i>" },

  // if the image option is not set, images are inserted as base64
  image: {
    uploadURL: "/api/upload",
    dropzoneOptions: {}
  },

  // limit content height if you wish. If not set, editor size will grow with content.
  maxHeight: "800px"
});

Vue.config.productionTip = false

const en = require('./locale/en.json')
const ko = require('./locale/ko.json')
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'ko',
  messages: {
    'en' : en,
    'ko' : ko
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  methods: {
    toggleLanguage() {
      this.$i18n.locale = (this.$i18n.locale=='en') ? 'ko' : 'en'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js